<style scoped>
    .body {
        position: relative;
        height: 100%;
        width: 100%;
        margin: 0;
        background-color: rgba(13, 42, 67, 0);
        background-image: url('./images/bg.png');
        /* background: rgba(14, 42, 66, 1); */
        /* border: 1px dashed #5a76ac; */
        box-shadow: rgba(0, 0, 0, 0.5) 0 0 30px 0;


    }

    .scroll-body {
        position: relative;
        height: 100%;
        width: 100%;
        margin: 0;
    }

    .background-container {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 0;
    }

    .components-container {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
    }

    .background-grid {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }
</style>
<template>
    <div class="scroll-body" :style="scrollStyles">
        <div ref="container" class="body">
            <div class="background-container" v-if="config&&config.background">
                <component :is="config.background.tag" v-bind="config.background.props"
                    style="width: 100%; height: 100%; display: block; position:absolute"
                    :style="{filter:config.background.filter}"></component>
            </div>
            <div v-if="isShowGrid" :style="gridStyles" class="background-grid" ref="grid"></div>
            <div class="components-container">
                <slot :config="config">
                    <container v-if="config" :config="config.componentTree"></container>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import mixin from "./mixin";
    import gridMixin from "./grid-minxin";
    import container from "./container";
    import bus from "./utils/bus";

    export default {
        name: "",
        props: ['isEdit'],
        data() {
            return {
                screen: {
                    width: null,
                    height: null
                },
                scaleX: 1, //缩放比例
                scaleY: 1,
                zoomFactor: 1.1, //缩放因子
                maxZoom: 2, //最大 scale 值
                minZoom: 0, //最小 scale 值
                isShowGrid: false,
                actualSize: {
                    w: 16,
                    h: 16,
                }
            };
        },
        mixins: [mixin, gridMixin],
        components: {
            container
        },
        computed: {
            gridStyles() {
                const pointSize = Math.min(Math.ceil(this.actualSize.w * this.scaleX / 16), 6);

                const size = this.actualSize.w;
                return {
                    // 'background': `#000`,
                    'background-image': `radial-gradient(#42425D ${pointSize}px, transparent ${pointSize}px)`,
                    'background-size': `${size}px ${size}px`,
                    'background-position-x': `${size/2}px`,
                    'background-position-y': `${size/2}px`,
                }
            },
            scrollStyles() {
                if (this.isEdit) {
                    return {

                    }
                } else {
                    return {}
                }

            }
        },
        methods: {
            /**
             * 创建一个新的
             */
            createEmpty({
                screen_w = 1920,
                screen_h = 1080,
            }) {
                this.screen.width = screen_w;
                this.screen.height = screen_h;
                this.$nextTick(() => {
                    this._setEditScreenScale({});
                    this.showGrid();
                });
            },
            resize() {
                this._setEditScreenScale({});
            },
            /**
             * 重置大屏分辨率,缩放比例不动
             * @param {}} w  分辨率 x
             * @param {*} h 分辨率y
             */
            resizeContainerWH(w, h) {
                const scaleX = this.screen.width / w;
                const scaleY = this.screen.height / h;
                let scale;
                if (scaleX < 1 || scaleY < 1) {
                    scale = Math.min(scaleX, scaleY)
                } else {
                    scale = Math.max(scaleX, scaleY)
                }

                this.screen.width = w;
                this.screen.height = h;
                this._setHtmlWH();
            },
            /** 
             * 宽度自适应缩放 呈现
             */
            autoWidthReveal() {
                this._setEditScreenScale({
                    wAuto: true,
                    hAtuto: false
                });
            },
            /** 
             * 高度自适应缩放 呈现
             */
            autoHeightReveal() {
                this._setEditScreenScale({
                    wAuto: false,
                    hAtuto: true
                });
            },
            /**
             * 设置格子大小
             */
            setGridSize(size) {
                this.actualSize.w = size;
                this.actualSize.h = size;
            },
            _setScale(val) {
                this.scaleX = this.scaleY = val;
                this._scaleHtml();
            },
            /**
             * 显示 并设置格子大小 
             * 参数 size: 格子大小
             */
            setGridSize(grid_size) {
                this.actualSize.w = this.actualSize.h = grid_size;
                this.isShowGrid = true;

            },
            /**  
             * 显示格子
             */
            showGrid() {
                this.isShowGrid = true;
            },
            /**隐藏 格子 */
            hideGrid() {
                this.isShowGrid = false;
            },
            /** 解析 json 描述并渲染 */
            loadPageConfig(json) {
                this.screen.width = json.width;
                this.screen.height = json.height;
                if (this.isEdit) {
                    this._setEditScreenScale({});
                } else {
                    this._setEditScreenScale({
                        wAuto: json.autoFit === 'width',
                        hAtuto: json.autoFit === 'height'
                    });
                }

                setTimeout(() => {
                    this.config = json;
                }, 200)

            },
            /** 
             * 容器放大一级
             */
            zoomIn() {

                const result = this.scaleX * this.zoomFactor;
                if (result > this.maxZoom) {
                    result = this.maxZoom;
                }

                if (this.scaleX !== result) {
                    this._setScale(result);
                }
            },
            /** 
             * 容器缩小一级
             */
            zoomOut() {
                const result = this.scaleX / this.zoomFactor;
                if (result > this.minZoom) {
                    this._setScale(result);
                }
            },

            zoomToOrgin() {
                this._setScale(1);
            },

            _setEditScreenScale({
                wAuto = false, //width 完全对齐
                hAtuto = false //height 高度对齐包含
            }) {
                const dom = this.$refs.container;
                const parentNode = dom.parentNode;

                const scaleX = parentNode.offsetWidth / this.screen.width;
                const scaleY = parentNode.offsetHeight / this.screen.height;

                if (this.isEdit) {
                    if (wAuto) {
                        this.scaleX = this.scaleY = scaleX;
                    } else if (hAtuto) {
                        this.scaleX = this.scaleY = scaleY;
                    } else {
                        const scale = Math.min(scaleX, scaleY);
                        this.scaleX = this.scaleY = scale;
                    }

                } else {
                    if (wAuto) {
                        this.scaleX = this.scaleY = scaleX;
                    } else if (hAtuto) {
                        this.scaleX = this.scaleY = scaleY;
                    } else {
                        this.scaleX = scaleX;
                        this.scaleY = scaleY;
                    }

                }
                this._setHtmlWH();
                this._scaleHtml();

            },
            _setHtmlWH() {
                const dom = this.isEdit ? this.$refs.container : document.body;
                const style = dom.style;
                if (this.isEdit) {
                    // style.overflow = "scroll";
                } else {
                    style.overflow = "hidden";
                }
                style.width = `${this.screen.width}px`;
                style.height = `${this.screen.height}px`;
            },
            _scaleHtml() {
                const dom = this.isEdit ? this.$refs.container : document.body;
                const style = dom.style;
                style.transform = `scale(${this.scaleX},${this.scaleY})`;
                style.transformOrigin = "left top";
            },

        },
        mounted() {
            bus.$on("loadData", this.loadPageConfig);
        },
        beforeDestroy() {
            bus.$off("loadData", this.loadPageConfig);
        }
    };
</script>